var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoupon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.375 9.5H22.375V12.4099C21.146 12.4099 20.1498 13.4062 20.1498 14.6351C20.1498 15.8641 21.146 16.8604 22.375 16.8604V19.7703H3.375V16.8604C4.60396 16.8604 5.60023 15.8641 5.60023 14.6351C5.60023 13.4062 4.60396 12.4099 3.375 12.4099V9.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.875 9.5V19.75",
    stroke: "white",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93311 8.00007H20.8791C21.0472 7.20715 21.6441 6.53492 22.4808 6.31076L21.7276 3.5L4.93311 8.00007Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupon);
export default __webpack_public_path__ + "static/media/coupon.a4e0f23d780e525a02b7bdb3c27dcc17.svg";
export { ForwardRef as ReactComponent };